export enum PrescriptionObservationOnBedEnum {
    PacienteNegouMedicacao = 1,
    Queixas = 2,
}